module.exports = __webpack_public_path__ + "static/media/asharimg.d78596ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/asharimg.jpg
// module id = 45
// module chunks = 0